
export const getStartDateForSubmit = (startDate) => {
  return (
    new Date(startDate).getFullYear() +
    "-" +
    (new Date(startDate).getMonth() + 1).toString().padStart(2, "0") +
    "-01"
  );
};

export const getEndDateForSubmit = (startDate, effectiveMonths) => {
  let endDateTransform = new Date(startDate);
  endDateTransform.setMonth(endDateTransform.getMonth() + (Number(effectiveMonths) + 1));
  endDateTransform.setDate(0);
  return endDateTransform.toISOString().split("T")[0];
};

export const getSelectedPressIds = (pressListBySeriesFilter) => {
  const selectedPressListToUpload = [];

  for (let i = 0; i < pressListBySeriesFilter.length; i++) {
    if (pressListBySeriesFilter[i].rowConfig.selected === true) {
      selectedPressListToUpload.push(pressListBySeriesFilter[i].idPress);
    }
  }

  return selectedPressListToUpload;
};

export const getCombineClicksIds = (combineClicksList) => {
  const combineClicksToUpload = [];

  for (let i = 0; i < combineClicksList.length; i++) {
    combineClicksToUpload.push(combineClicksList[i].endUserCombineClicks);
  }

  return combineClicksToUpload;
};

export const getSpecialConditionTooltipDescription = (specialConditionType, t) => {
  switch (specialConditionType) {
    case 1:
      return "Maximum Cost per Impression"; //return t("tooltip.sc1");
    case 2:
      return "Bonus Special Table"; //return t("tooltip.sc2");
    case 3:
      return "Fixed Bonus"; //return t("tooltip.sc3");
    case 4:
      return "Tiers UP"; //return t("tooltip.sc4");
    case 7:
      return "Combine Clicks "; //return t("tooltip.sc7");
    case 8:
      return "Combine Clicks + Special Table"; //return t("tooltip.sc8");
    case 11:
      return "Minimum Discount"; //return t("tooltip.sc11");
    case 12:
      return "Bonus Special Table + EPM"; //return t("tooltip.sc12");
    case 13:
      return "Maximum CPP LS Mark"; //return t("tooltip.sc13");
    case 14:
      return "Fixed Bonus + EPM"; //return t("tooltip.sc14");
    case 15:
      return "Bonus Special Table - All Imp"; //return t("tooltip.sc15");
    case 17:
      return "Combine Clicks + Spl Tbl EPM"; //return t("tooltip.sc17");
    case 19:
      return "Combine Clicks + Tiers Up"; //return t("tooltip.sc19");
    case 21:
      return "Run Length"; //return t("tooltip.sc21");
    case 22:
      return "Maximum CPP - LS Mark Program"; //return t("tooltip.sc22");
    case 23:
      return "Low Coverage Program"; //return t("tooltip.sc23");
    case 25:
      return "Frame Width"; //return t("tooltip.sc25");
    case 26:
      return "Lifespan Gate"; //return t("tooltip.sc26");
    default:
      return "";
  }
};
